import { render, staticRenderFns } from "./ExtraEdit.vue?vue&type=template&id=95ae789a"
import script from "./ExtraEdit.vue?vue&type=script&lang=js"
export * from "./ExtraEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports